<template>
  <div class="card__button">
    <button
      v-show="buttonLoading"
      class="button button--tight"
      :class="buttonClass"
      style="min-width: 91px"
    >
      <LoaderComponent :show="true"></LoaderComponent>
    </button>
    <button
      v-show="!buttonLoading"
      class="button button--tight"
      :class="buttonClass"
      name="customer_shop_package"
      @click="emitBuy"
    >
      <span>{{ trans.get('ms:shop.buy_now_button') }}</span>
    </button>
  </div>
</template>

<script>
import LoaderComponent from './../LoaderComponent.vue';

export default {
  name: 'ElementButton',
  components: { LoaderComponent },
  props: {
    buttonLoading: Boolean,
    buttonClass: Object,
  },
  methods: {
    emitBuy: function () {
      this.$emit('buy');
    },
  },
};
</script>
